import Link from 'next/link';

import offsetBlockClass from '@/utils/offsetBlockClass';

export default async function SidebarBottomLink({ block, position }) {
  const { link_text, url, show_offset_block_selector, _metadata } =
    block.sidebar_bottom_link;

  return (
    <section
      id={`${_metadata.uid}_${position}`}
      data-name="sidebar-bottom-link"
      className={`${offsetBlockClass(show_offset_block_selector, 'not-last:mb-8')}`}
    >
      {url && (
        <Link href={url} prefetch={false}>
          {link_text && (
            <span className="body-s text-crisp-white flex justify-center pb-2 underline underline-offset-8">
              {link_text}
            </span>
          )}
        </Link>
      )}
    </section>
  );
}
